import { createClaudeFamilyCliDefinition } from "./factory.js";

export const claudeCli = createClaudeFamilyCliDefinition({
  id: "claude",
  label: "Claude",
});
